(function () {
  'use strict';

  var requestInFlight = false;
  var refreshQueued = false;
  var refreshTimer;

  function getRootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function refreshConversion() {
    var drawer = document.querySelector('#t4s-mini_cart');
    var liveConversion = drawer && drawer.querySelector('[data-cart-conversion]');

    if (!liveConversion) {
      return;
    }

    if (requestInFlight) {
      refreshQueued = true;
      return;
    }

    requestInFlight = true;

    fetch(getRootUrl() + '?section_id=mini_cart&okb_cart=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('La section du panier n\'a pas pu être actualisée.');
        }
        return response.text();
      })
      .then(function (markup) {
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var freshConversion = parsed.querySelector('[data-cart-conversion]');
        var currentConversion = document.querySelector('#t4s-mini_cart [data-cart-conversion]');

        if (freshConversion && currentConversion) {
          currentConversion.innerHTML = freshConversion.innerHTML;
        }
      })
      .catch(function (error) {
        console.warn('[OKB] Actualisation des informations du panier impossible.', error);
      })
      .then(function () {
        requestInFlight = false;

        if (refreshQueued) {
          refreshQueued = false;
          scheduleRefresh();
        }
      });
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshConversion, 80);
  }

  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);
}());
